import { externInvoicesActions, s3Actions, useSelector } from "inbooma-api";
import React, { useEffect, useState } from "react";
import { Biscuit, getAllUrlParams } from "../../../../utils";
import showNotification from "../../../helpers/showNotification";
import t from "../../../helpers/t";
import { $, moment } from "../../../../../vendor";
import InvoiceSidebar from "./InvoiceSidebar";
import InboomaSubmenu from "../../../components/InboomaSubmenu";
import SortNav from "../../../components/SortNav";
import Paginator from "../../../components/paginator";
import Loader from "../../../components/Loader";
import { getDocHandler, in_array } from "../../../../utils/Helper";
import InvoicesList from "./InvoicesList";
import { isViewVisible } from "../../../../utils/ViewSettings";
import { getApiHost } from "../../../../Sync";
import * as FileSaver from "../../../../../vendor/FileSaver";
import ShowUploadDialog from "./ShowUploadDialog";

const InvoicesView = (props) => {
  const { dispatch, params, action, returnPath } = props;
  const currentUrl = new URL(window.location.href);
  const language = Biscuit.get("user.lang").replace("-", "_");
  const searchParams = currentUrl.searchParams;
  let allUrlParams = getAllUrlParams(window.location.href);
  if (typeof allUrlParams.name !== "undefined") {
    console.log(allUrlParams.name);
    allUrlParams.name = allUrlParams.name.replaceAll("+", "");
    allUrlParams.name = allUrlParams.name.replaceAll(" ", "");
  }
  const paginationLimit = 40;
  const [showUploadDialog, setShowUploadDialog] = useState(false);
  const [pagination, setPagination] = useState({
    has_next_page: false,
    current_page: 1,
  });
  const [_key, setKey] = useState(null);
  const [withActions, setWithActions] = useState(true);
  let mainMenu = document.getElementById("inb-main-menu");
  if (mainMenu !== undefined && mainMenu != null && mainMenu.querySelector(".l-invoices")) {
    if (mainMenu.querySelector(".active") != null)
      mainMenu.querySelector(".active").classList.remove("active");
    mainMenu.querySelector(".l-users").classList.add("active");
  }
  let cleanStateFilters = {
    sort: "invoiceDate",
    direction: "desc",
    limit: paginationLimit,
    page: pagination.current_page,
    withTrashed: false,
  };
  const [filters, setFilters] = useState({
    ...cleanStateFilters,
    ...allUrlParams,
  });
  const [sort, setSort] = useState({
    sort: allUrlParams?.sort !== undefined ? allUrlParams.sort : "invoiceDate",
    direction: allUrlParams?.direction !== undefined ? allUrlParams.direction : "desc",
  });
  const _queryState = {
    timeStamp: 0,
    value: "",
  };
  const [checkedItems, setCheckedItems] = useState(function () {
    let checked = [],
      response = {};
    if (typeof allUrlParams.selected !== "undefined") {
      let params = allUrlParams.selected;
      checked = params.split("k");
    }
    if (checked.length < 1) {
      return {};
    }
    checked.map((c) => {
      response[c] = true;
    });
    return response;
  });
  const [selectedItems, setSelectedItems] = useState(function () {
    let checked = [];
    if (typeof allUrlParams.selected !== "undefined") {
      let params = allUrlParams.selected;
      checked = params.split("k");
    }
    return checked.length;
  });
  const [allSelected, setAllSelected] = useState(
    typeof allUrlParams.selectedall !== "undefined" ? allUrlParams.selectedall : false,
  );
  const [oneItemChecked, setOneItemChecked] = useState(function () {
    let checked = [];
    if (typeof allUrlParams.selected !== "undefined") {
      let params = allUrlParams.selected;
      checked = params.split("k");
    }
    if (checked.length > 0) {
      return true;
    }
    return false;
  });
  const [showMultiEditDialog, setShowMultiEditDialog] = useState(
    typeof allUrlParams.multiedit !== "undefined" ? allUrlParams.multiedit : false,
  );
  const [shouldSave, setShouldSave] = useState(false);
  const _getDocument = useSelector((state) => state.s3_data.getDocumentS3);
  const [getDocumentPending, setGetDocumentPending] = useState(false);
  const _externInvoices = useSelector((state) => state.extern_invoices_data.externInvoices);
  const _externInvoicesSummary = useSelector(
    (state) => state.extern_invoices_data.externInvoicesSummary,
  );
  const _getSepaXML = useSelector((state) => state.extern_invoices_data.getSepaXML);
  const _syncExternInvoices = useSelector((state) => state.extern_invoices_data.syncExternInvoices);
  const [externInvoices, setExternInvoices] = useState([]);
  const [nameList, setNameList] = useState([]);
  const [externInvoicesSummary, setExternInvoicesSummary] = useState([]);
  const [sepaXML, setSepaXML] = useState(null);
  const [externInvoicesPending, setExternInvoicesPending] = useState(false);
  const [nameListPending, setNameListPending] = useState(false);
  const [externInvoicesSummaryPending, setExternInvoicesSummaryPending] = useState(false);
  const [sepaXMLPending, setSepaXMLPending] = useState(false);
  const [syncExternInvoicesPending, setSyncExternInvoicesPending] = useState(null);
  const [initialized, setInitialized] = useState(false);

  useEffect(() => {
    if (_getDocument.success === "" || !getDocumentPending) {
      return;
    }
    if (_getDocument.success === true) {
      const blob = new Blob([_getDocument.data], { type: _getDocument.data.type });
      FileSaver.saveAs(blob, getDocumentPending.replace(/_/gi, " "));
    } else {
      alert("Could not download: " + _getDocument.data);
    }
    setGetDocumentPending(false);
  }, [_getDocument]);

  useEffect(() => {
    if (externInvoicesPending) {
      return;
    }

    props.dispatch(
      externInvoicesActions.getExternInvoices({
        token: Biscuit.get("token"),
        filter: filters,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    dispatch(
      externInvoicesActions.getExternInvoicesSummary({
        token: Biscuit.get("token"),
        filter: filters,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setExternInvoicesSummaryPending(true);
    setExternInvoicesPending(true);
  }, [filters]);

  useEffect(() => {
    if (
      !initialized &&
      !externInvoicesPending &&
      !sepaXMLPending &&
      !syncExternInvoicesPending &&
      !externInvoicesSummaryPending &&
      !nameListPending
    ) {
      dispatch(externInvoicesActions.getExternInvoicesResetData());
      let requestFilter = { ...filters };
      requestFilter = { ...requestFilter, page: pagination.current_page };
      requestFilter = { ...requestFilter, limit: paginationLimit };
      requestFilter = { ...requestFilter, ...allUrlParams };
      requestFilter = { ...requestFilter, withTrashed: false };
      setNameListPending();
      console.log(requestFilter, "filters");
      dispatch(
        externInvoicesActions.getExternInvoices({
          token: Biscuit.get("token"),
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setExternInvoicesPending(true);
      dispatch(
        externInvoicesActions.getExternInvoicesSummary({
          token: Biscuit.get("token"),
          filter: requestFilter,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setExternInvoicesSummaryPending(true);
    }
  }, []);
  useEffect(() => {
    if (_syncExternInvoices.success === "" || !syncExternInvoicesPending) return;

    if (_syncExternInvoices.success === true) {
      showNotification("success", null, null, "invoice");
    } else {
      let message = _syncExternInvoices.data.message;
      showNotification("warning", null, message, "invoice");
    }
    setSyncExternInvoicesPending(false);
  }, [_syncExternInvoices]);

  useEffect(() => {
    if (!sepaXMLPending) return;

    if (_getSepaXML.length) {
      setSepaXML(_getSepaXML);

      showNotification("success", null, null, "invoice");
    } else {
      showNotification("warning", null, "FAIL", "invoice");
    }
    setSepaXMLPending(false);
  }, [_getSepaXML]);

  useEffect(() => {
    if (_externInvoices.success === "" || !externInvoicesPending) return;
    console.log(_externInvoices, "_externInvoices");
    if (_externInvoices.success === true) {
      let externInv = [];
      _externInvoices?.data?.forEach((inv) => {
        let externInvoiceRevisions = inv.extern_invoices_revisions[0];
        externInvoiceRevisions.externalClientId = inv.externalClientId;
        externInvoiceRevisions.invoiceNbr = inv.invoiceNbr;
        externInvoiceRevisions.system = inv.sys;
        externInvoiceRevisions.invoiceDate = inv.invoiceDate;
        externInv.push(externInvoiceRevisions);
      });
      setExternInvoices(externInv);
      setPagination(_externInvoices.pagination);
      setNameList(getNameList(externInv));
    }
    setExternInvoicesPending(false);
    if (!nameListPending && !externInvoicesSummaryPending) {
      setInitialized(true);
    }
  }, [_externInvoices]);

  useEffect(() => {
    if (_externInvoicesSummary.success === "" || !externInvoicesSummaryPending) return;

    if (_externInvoicesSummary.success === true) {
      setExternInvoicesSummary(_externInvoicesSummary.data);
    }
    setExternInvoicesSummaryPending(false);
    if (!nameListPending && !externInvoicesPending) {
      setInitialized(true);
    }
  }, [_externInvoicesSummary]);

  const getNameList = (externInvoices) => {
    let names = [];
    externInvoices.map((externInvoice) => {
      if (!in_array(externInvoice.extern_invoices_client_datas[0].name, names)) {
        names.push(externInvoice.extern_invoices_client_datas[0].name);
      }
    });
    let clone2 = [];
    let clone = {
      name: "Alle",
      value: "",
    };
    clone2.push(clone);
    names.map((name) => {
      if (name !== "" && name !== " ") {
        let clone = {
          name: name,
          value: name,
        };
        clone2.push(clone);
      }
    });
    setNameListPending(false);
    return clone2;
  };

  const _readFile = (externInvoice) => {
    const file_name = externInvoice.file;
    props.dispatch(
      s3Actions.getDocumentS3({
        client_id: externInvoice.externalClientId,
        type: "Invoices",
        location: null,
        name: file_name,
        apiEntryPoint: getApiHost(),
        token: Biscuit.get("token"),
      }),
    );
    setGetDocumentPending(file_name);
  };

  const onSearchbarChanged = (ev) => {
    let query;
    if (typeof ev.target !== "undefined") {
      query = ev.target.value.toLowerCase();
    } else {
      query = "";
    }
    searchParams.delete("q");
    if (query !== "") {
      searchParams.set("q", query);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);

    const minLength = 3;

    if (query.length >= minLength) {
      // work user search only for values bigger or equal to the minimum length

      setTimeout(function () {
        let diff = Number(moment().format("x")) - _queryState.timeStamp;
        if (diff > 700 && _queryState.value === query) {
          // no changes after the last 700 ms -> user finished input -> start request
          dispatch(
            externInvoicesActions.getExternInvoices({
              token: Biscuit.get("token"),
              filter: {
                ...filters,
                q: query,
              },
              parameters: {
                headers: {
                  "Accept-Language": language,
                  "Content-Language": language,
                },
              },
            }),
          );
          setExternInvoicesPending(true);
          setFilters({
            ...filters,
            q: query,
          });
        }
      }, 800);
    } else if (filters.q !== undefined) {
      // reset filter when query was active
      let clone = { ...filters };
      delete clone.q;
      setFilters(clone);
      props.dispatch(
        externInvoicesActions.getExternInvoices({
          token: Biscuit.get("token"),
          filter: {
            ...clone,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setExternInvoicesPending(true);
    } else {
      let clone = { ...filters };
      delete clone.q;
      setFilters(clone);
      props.dispatch(
        externInvoicesActions.getExternInvoices({
          token: Biscuit.get("token"),
          filter: {
            ...clone,
          },
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setExternInvoicesPending(true);
    }
    _queryState.timeStamp = Number(moment().format("x"));
    _queryState.value = query;
  };

  const onFilterChanged = (filterLocal) => {
    //const _filter = {'sort': 'invoiceDate','direction': 'desc'};
    let clone = {};
    Object.assign(clone, filters);
    Object.keys(filterLocal).map((key) => {
      clone[key] = filterLocal[key];
    });
    setFilters(clone);
  };

  const loadNextPage = (page) => {
    setExternInvoicesPending(true);
    // request next page
    props.dispatch(
      externInvoicesActions.getExternInvoices({
        token: Biscuit.get("token"),
        filter: {
          ...filters,
          page: page,
        },
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
  };

  const onChangeSort = (ev) => {
    const el = ev.currentTarget;

    const sortKey = el.getAttribute("data-inb-val"),
      direction = el.getAttribute("data-inb-direction"),
      isOppositeElement = direction === null && el.classList.contains("is-active"),
      newDirection = direction === "desc" || isOppositeElement ? "asc" : "desc";

    if (sortKey) {
      let filter = {
        sort: sortKey,
        direction: direction,
      };

      setFilters(Object.assign(filters, filter));

      props.dispatch(
        externInvoicesActions.getExternInvoices({
          token: Biscuit.get("token"),
          filter: filters,
          parameters: {
            headers: {
              "Accept-Language": language,
              "Content-Language": language,
            },
          },
        }),
      );
      setExternInvoicesPending(true);
      const activeSortTab = $(".is-active");

      for (let tab = 0; tab < activeSortTab.length; tab++) {
        activeSortTab[tab].classList.remove("is-active");
      }
      el.classList.add("is-active");
      el.setAttribute("data-inb-direction", isOppositeElement ? "desc" : newDirection);
    }
  };

  const selectAll = (e, val) => {
    setAllSelected(val);
    let clone = {};
    Object.assign(clone, checkedItems);
    if (val) {
      let paramValues = [];
      externInvoices.map((externInvoice) => {
        paramValues.push(externInvoice.id);
        clone[externInvoice.id] = true;
      });
      searchParams.set("selected", paramValues.join("k"));
      searchParams.set("selectedall", true);
      setCheckedItems(clone);
      setOneItemChecked(true);
      setSelectedItems(paramValues.length);
    } else {
      setCheckedItems({});
      searchParams.delete("selected");
      searchParams.delete("selectedall");
      setOneItemChecked(false);
      setSelectedItems(0);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  let tabs = [];
  if (withActions) {
    tabs.push({
      name: "checkAll",
      mediumWidth: 1,
      smallWidth: 1,
      xlargeWidth: 1,
      extraClasses: "large-1",
      title: t("select all"),
      isCheckbox: true,
      value: allSelected,
      onChange: selectAll,
      label: "",
      checkBoxLabel: t("all"),
      checkBoxStyle: { paddingTop: "7%" },
      style: { minWidth: "170px", paddingLeft: "2.5%" },
    });
  }
  tabs.push({
    name: t("invoiceDate", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    preselected: true,
    title: t("sort_by_${a}", { a: t("invoiceDate", null, "capital") }, "capital"),
    canSort: true,
    sort: {
      direction: "desc",
      data_inb_val: "invoiceDate",
    },
  });
  tabs.push({
    name: t("invoiceNbr", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("invoiceNbr", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "invoiceNbr",
    },
  });
  tabs.push({
    name: t("amount", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("sort_by_${a}", { a: t("amount") }, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "amount",
    },
  });
  tabs.push({
    name: t("paymentMethod", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "large-1",
    title: t("paymentMethod", null, "capital"),
    canSort: true,
    sort: {
      direction: "desc",
      data_inb_val: "paymentMethod",
    },
  });

  tabs.push({
    name: t("paymentStatus", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("paymentStatus", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "paymentStatus",
    },
  });
  tabs.push({
    name: t("paymentDate", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("paymentDate", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "paymentDate",
    },
  });
  tabs.push({
    name: t("dueDate", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("dueDate", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "dueDate",
    },
  });
  tabs.push({
    name: t("warningLevel", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("warningLevel", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "warningLevel",
    },
  });
  tabs.push({
    name: t("mwst", null, "capital"),
    smallWidth: 6,
    mediumWidth: 1,
    xlargeWidth: 1,
    extraClasses: "column large-1",
    title: t("mwst", null, "capital"),
    canSort: true,
    sort: {
      direction: "asc",
      data_inb_val: "mwst",
    },
  });
  /*tabs.push({
        name: t('mwstAmount', null, 'capital'),
        smallWidth: 6,
        mediumWidth: 1,
        extraClasses: 'column large-1',
        title: t('mwstAmount', null, 'capital'),
        canSort: true,
        sort: {
            direction: 'asc',
            data_inb_val: 'mwstAmount'
        }
    });*/
  const submenuItems = [
    {
      name: t("transactions", null, "capital"),
      link: "finances/transactions",
      data_inb_val: t("transactions", null, "capital"),
      icon: "fi fi-dollar",
      isActive: false,
      isAccessible: isViewVisible("transactions", "finances"),
    },
    {
      name: t("sales_billings", null, "capital"),
      link: "finances/sales_billings",
      data_inb_val: t("sales_billings", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: isViewVisible("salesBillings", "finances"),
    },
    {
      name: t("payment_accounts", null, "capital"),
      link: "finances/payment_accounts",
      data_inb_val: t("payment_accounts", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: false && isViewVisible("paymentAccounts", "finances"),
    },
    {
      name: t("insurances", null, "capital"),
      link: "finances/insurances",
      data_inb_val: t("insurances", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("admin transactions", null, "capital"),
      link: "finances/admin_transactions",
      data_inb_val: t("admin transactions", null, "capital"),
      icon: "fi fi-list",
      isActive: false,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
    {
      name: t("invoices", null, "capital"),
      link: "invoices",
      data_inb_val: t("invoices", null, "capital"),
      icon: "fi fi-list",
      isActive: true,
      isAccessible: Biscuit.get("user.is_superuser") === "true",
    },
  ];

  const onCheckBox = (e, id) => {
    let clone = {};
    Object.assign(clone, checkedItems);
    searchParams.delete("selectedall");
    setAllSelected(false);
    clone[id] = e.target.checked;

    let params = [];
    Object.keys(clone).map((id) => {
      if (clone[id]) {
        params.push(id);
      }
    });
    if (params.length < 1) {
      searchParams.delete("selected");
      searchParams.delete("selectedall");
    } else {
      if (externInvoices.length === params.length) {
        searchParams.set("selectedall", true);
        searchParams.delete("selected");
        setAllSelected(true);
      } else {
        searchParams.set("selected", params.join("k"));
      }
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
    setCheckedItems(clone);
    setOneItemChecked(false);
    let count = 0;
    Object.keys(clone).map((val, key) => {
      if (clone[val]) {
        setOneItemChecked(true);
        count++;
      }
    });
    setSelectedItems(count);
  };
  const createSEPAXML = (e, val) => {
    let datas = [];
    Object.keys(checkedItems).map((val, key) => {
      datas.push(val);
    });
    if (datas.length > 0) {
      //  setAction('edited');
      /*let payload = {
                    token: Biscuit.get('token'),
                    data: {
                            "ips": datas.join(',')
                    },
                    parameters: {
                        headers: {
                            'Accept-Language': language,
                            'Content-Language': language
                        }
                    }
                };
                props.dispatch(externInvoicesActions.getSepaXML(payload));*/
      getDocHandler(
        "/externInvoices/getSepaXML",
        "POST",
        "application/xml",
        "SEPA.xml",
        "",
        null,
        { ips: datas.join(",") },
        false,
        true,
      );
      setSelectedItems(0);
      searchParams.delete("multiselect");
      setCheckedItems({});
      searchParams.delete("selected");
      searchParams.delete("selectedall");
      setOneItemChecked(false);
      setAllSelected(false);
      setSepaXMLPending(true);
      setShouldSave(false);
    } else {
      getDocHandler(
        "/externInvoices/getSepaXML",
        "GET",
        "application/xml",
        "SEPA.xml",
        "",
        null,
        {},
        false,
        true,
      );
      setSelectedItems(0);
      searchParams.delete("multiselect");
      setCheckedItems({});
      searchParams.delete("selected");
      searchParams.delete("selectedall");
      setOneItemChecked(false);
      setAllSelected(false);
      setSepaXMLPending(true);
      setShouldSave(false);
    }
    const newRelativePathQuery = window.location.pathname + "?" + searchParams.toString();
    history.pushState(null, "", newRelativePathQuery);
  };

  const cleanString = (val) => {
    if (val.contains("%3D")) {
      let temp = val.split("%3D");
      return temp[0];
    }
    return val;
  };

  const getInvoiceApi = () => {};

  const sync = (type) => {
    props.dispatch(
      externInvoicesActions.syncExternInvoices({
        token: Biscuit.get("token"),
        update: type,
        parameters: {
          headers: {
            "Accept-Language": language,
            "Content-Language": language,
          },
        },
      }),
    );
    setExternInvoicesPending(true);
  };

  const uploadInvoiceCSV = () => {
    setShowUploadDialog(true);
  };

  const handleCloseDialog = () => {
    setShowUploadDialog(false);
  };

  return (
    <>
      {initialized && (
        <InvoiceSidebar
          setFilter={onFilterChanged}
          setFilters={setFilters}
          filter={filters}
          sync={sync}
          uploadInvoiceCSV={uploadInvoiceCSV}
          nameList={nameList}
          cleanStateFilters={cleanStateFilters}
          externInvoicesSummaryPending={externInvoicesSummaryPending}
          externInvoicesSummary={externInvoicesSummary}
          currentUrl={currentUrl}
          getSepaXML={createSEPAXML}
        />
      )}
      <div id="inb-c-main" className="columns user">
        <InboomaSubmenu
          tabs={submenuItems}
          extraClasses={"sticky-top"}
          searchbar={false}
          searchbarPlaceholder={t("username") + " / ID / " + t("e-mail")}
          searchbarValue={allUrlParams?.q !== undefined ? allUrlParams.q : ""}
          searchbarHandler={onSearchbarChanged}
          smallOnlyTitle={t("invoices", null, "capital")}
          pagination={pagination}
          onChange={loadNextPage}
          initialized={initialized}
          itemLength={externInvoices.length}
          itemsCountPerPage={paginationLimit}
          pageRangeDisplayed={5}
          multiSelect={withActions}
          //setPaginationLimit={setPaginationLimit}
          oneItemChecked={oneItemChecked}
          selectedItemsCount={selectedItems}
          model={t("invoices", null, "capital")}
          withActions={withActions}
          setWithActions={setWithActions}
          multiSwitchOptions={
            withActions
              ? [
                  /*  oneItemChecked && {
                        label: t('delete'),
                        multiEvent: multiDelete,
                        value: null
                    },*/
                  oneItemChecked && {
                    label: t("create Sepa XML"),
                    multiEvent: createSEPAXML,
                    value: null,
                  },
                  oneItemChecked && {
                    label: t("select none"),
                    multiEvent: selectAll,
                    value: false,
                  },
                ]
              : []
          }
        />
        <SortNav
          tabs={tabs}
          /* margStyle={"15px"} */
          extraClasses={"sticky-top-sortbar"}
          listStyle="tight"
          handler={onChangeSort}
        />
        {/* {typeof pagination !== 'undefined' &&
                <Paginator
                    pagination={pagination}
                    itemsCountPerPage={paginationLimit}
                    pageRangeDisplayed={5}
                    onChange={loadNextPage}
                    upper={true}
                />} */}
        {initialized && externInvoices.length > 0 && !externInvoicesPending && (
          <InvoicesList
            invoices={externInvoices}
            dispatch={dispatch}
            filterChangedHandle={onFilterChanged}
            filter={filters}
            setFilter={setFilters}
            sort={sort}
            setSort={setSort}
            _key={_key}
            setKey={setKey}
            params={params}
            showNotification={showNotification}
            checkedItems={checkedItems}
            _readFile={_readFile}
            onCheckBox={onCheckBox}
            withActions={withActions}
          />
        )}
        {!externInvoicesPending && externInvoices.length < 1 && (
          <>
            <div id="inb-app-collection-empty" className="inb-announcement">
              <div className="inb-image-box">
                <img alt="No Data" src={"assets/img/no_data.svg"} />
              </div>
              <h3>{t("app_msg_collection_empty")}</h3>
              <p>{t("app_msg_collection_empty_body")}</p>
            </div>
          </>
        )}
        {externInvoicesPending && <Loader mediumWidth={2} smallWidth={4} subLoaders={5} />}
        {showUploadDialog && (
          <ShowUploadDialog
            handleCloseDialog={handleCloseDialog}
            dispatch={dispatch}
            filter={filters}
            onFilterChanged={onFilterChanged}
            index={_key}
            _key={_key}
            setNKey={setKey}
            sort={sort}
            setSort={setSort}
            currentUrl={currentUrl}
            checkedItems={checkedItems}
            onCheckBox={onCheckBox}
            _readFile={_readFile}
            withActions={withActions}
            setWithActions={setWithActions}
          />
        )}
      </div>
    </>
  );
};

export default InvoicesView;
